import React from "react";
import styles from "./WhatsAppButton.module.css";
import { WHATSAPP_LINK } from "../siteData";

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      className={styles.fab}
      aria-label="Chat with us on WhatsApp"
    >
      <span className={styles.pulse} aria-hidden="true" />
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12.04 2c-5.5 0-9.96 4.46-9.96 9.96 0 1.76.46 3.48 1.34 4.99L2 22l5.2-1.36a9.9 9.9 0 0 0 4.84 1.24h.01c5.5 0 9.96-4.46 9.96-9.96S17.54 2 12.04 2Zm5.83 14.24c-.25.7-1.24 1.28-2.03 1.44-.55.11-1.26.2-3.66-.79-2.86-1.19-4.79-3.98-4.94-4.16-.14-.19-1.19-1.58-1.19-3.01 0-1.43.75-2.13 1.02-2.42.25-.29.57-.36.76-.36.19 0 .38 0 .55.01.18.01.42-.07.65.5.25.6.85 2.07.92 2.22.07.15.12.32.02.51-.1.19-.15.31-.29.48-.14.17-.3.37-.43.5-.14.14-.29.29-.13.57.16.28.72 1.19 1.55 1.93 1.06.94 1.96 1.24 2.24 1.38.28.14.44.12.6-.07.17-.19.72-.83.91-1.12.19-.28.38-.24.64-.14.26.1 1.66.78 1.94.92.28.14.47.21.53.33.07.12.07.68-.18 1.38Z" />
      </svg>
    </a>
  );
}
